export default {
  authUser: () => () => JSON.parse(localStorage.getItem('authUser')),
}
